<template>
  <div class="report-graphs-section">
    <div class="graph-row">
      <!--<frequent-spend-report ref="frequent"-->
                             <!--:wrapperWidth="frequent.width"></frequent-spend-report>-->

      <recipients-report ref="recipients"
                         :apiParams="apiParams"
                         :graphData="recipients.data"
                         :error="recipients.error"
                         :wrapperWidth="recipients.width"
                         @loadGraphData="loadGraphData"></recipients-report>

      <div class="divider"></div>

      <trend-line-report ref="trends"
                         :apiParams="apiParams"
                         :dateTicks="trends.dateTicks"
                         :error="trends.error"
                         :graphData="trends.data"
                         :wrapperWidth="trends.width"
                         @loadGraphData="loadGraphData"></trend-line-report>
    </div>

    <!-- saving this for when frequent spend is completed -->
    <!--<div class="divider"></div>-->
    <!--<div class="graph-row bottom">-->
      <!--<trend-line-report ref="trends"-->
                         <!--:graphData="trends.data"-->
                         <!--:wrapperWidth="trends.width"-->
                         <!--@loadGraphData="loadGraphData"></trend-line-report>-->
    <!--</div>-->

  </div>
</template>


<script>
  // import FrequentSpendReport from './FrequentSpendReport'
  import GraphData from '../mixins/GraphData'
  import RecipientsReport from './RecipientsReport'
  import TrendLineReport from './TrendLineReport'

  export default {
    props: {
      adId: [Number, String],
      advertiserId: [Number, String],
      advertiserTimezone: String,
      apiParams: Object,
      retailerIds: Array,
    },

    name: 'ReportGraphs',

    components: {
      // FrequentSpendReport,
      RecipientsReport,
      TrendLineReport,
    },

    mixins: [GraphData],

    data() {
      return {
        frequent: {},
        recipients: {},
        trends: {},
      }
    },

    methods: {
      configureGraphData(data, graphType) {
        let graphData = this.buildGraphData(data)
        this.getStartEndDates(data, graphType)
        if (graphType) { this.$set(this[graphType], 'data', graphData) }
      },

      loadGraphData(url, graphType, metric) {
        // graph types
        // 1) recipients
        // 2) trends
        // 3) frequent
        let errorMessage = `we encountered an issue loading the ${graphType} graph`,
          params = {
            brand_campaign_id: this.apiParams.params.brand_campaign_id,
            brand_id: this.apiParams.params.brand_id,
            merchant_id: this.apiParams.params.merchant_id,
            metric: metric
          }
        this.$api.get(url, { params: params })
          .then((response) => {
            const data = response.data,
              hasError = data.error
            if (data && !hasError) {
              this.configureGraphData(data.data, graphType)
              if (this[graphType].error) { this.$delete(this[graphType], 'error') }
            } else {
              errorMessage = hasError ? `${errorMessage}: ${hasError}` : errorMessage
              this.$set(this[graphType], 'error', errorMessage)
            }
          })
          .catch((error) => {
            let eMessage;
            if (error || error.response?.status === 404) {
              eMessage = error.response.data.error
            } else {
              eMessage = `${errorMessage}: ${error}`
            }
            this.$set(this[graphType], 'error', eMessage)
          })
      },

      setWrapperWidths() {
        const view = this,
          graphTypes = ['recipients', 'trends']
          // graphTypes = ['frequent', 'recipients', 'trends']
        graphTypes.forEach((graph) => {
          let width = view.$refs[graph].$el.offsetWidth
          view.$set(view[graph], 'width', width)
        })
      },
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'
//
//  all reports section
//
.report-graphs-section
  align-items: center
  border-bottom: 1px solid $primary-transparent
  border-top: 1px solid $primary-transparent
  display: flex
  flex-direction: column
  padding: 1em 0
  margin: 0 auto
  max-width: 1000px

  .error-label
    color: $negative-hover
    font-size: 0.9rem
    margin-top: 0.25rem

  .data-title
    font-size: 1.5rem
    margin-bottom: 1rem

  .link-toggle-wrapper
    color: $primary-color
    cursor: pointer

    .link-toggle
      max-height: 0
      overflow: hidden
      transition: max-height 0.5s ease

      &.open
        max-height: 100px

  .clickable-list-wrapper
    color: $primary-color
    display: flex
    font-size: 1.15em
    justify-content: center
    list-style: none
    margin: 0
    overflow: hidden
    transition: max-height 0.5s ease

    &.open
      max-height: 100px

    &.close
      max-height: 0

    .clickable-list-item
      cursor: pointer
      line-height: 1.1
      text-align: center

      span
        border-right: 1px solid $primary-transparent
        display: inline-block
        padding: 0 0.5em

      &:hover
        font-weight: bold

      &:last-child span
        border: none

  .divider
    margin: 2rem auto
    width: 70%

    &.vertical
      border-right: 1px solid $primary-transparent
      border-top: none
      margin: 7% 1em
      width: 1px

  .graph-row
    width: 80%

    @media only screen and (max-width: 40em)
      width: 100%

  .frequent-spend-reports-section,
  .opt-out-report-section,
  .recipients-graph-section,
  .trend-line-report-section
    flex: 1

  .report-legend
    display: flex
    justify-content: center

</style>